import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const ThreadCard = ({ thread }) => {
  const handleShare = async () => {
    const shareData = {
      title: thread.title || thread.hook,
      text: thread.content || thread.summary,
      url: window.location.href
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        alert("Link copied to clipboard!");
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  return (
    <article className="editorial-card p-5 md:p-6 w-full max-w-[800px] mx-auto flex flex-col gap-4">
      {/* Header / Meta */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2 text-[13px] md:text-[14px] font-mono text-brand-secondary uppercase tracking-widest">
          <span className="font-bold text-brand-text">{thread.platform || 'Thread'}</span>
          <span className="text-brand-borderHover">•</span>
          <span>{thread.date || 'Just now'}</span>
        </div>
        <div className="flex gap-4 text-brand-muted">
          <button onClick={handleShare} className="hover:text-brand-text transition-colors pointer-events-auto" aria-label="Share">
            <SafeIcon icon="Share2" className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div>
        <h2 className="text-[26px] md:text-[32px] lg:text-[36px] font-bold text-brand-text leading-tight mb-3">
          {thread.title || thread.hook}
        </h2>
        {thread.author && (
          <p className="text-[14px] md:text-[16px] font-mono font-bold text-brand-mint mb-4">By {thread.author}</p>
        )}
        <p className="text-[18px] md:text-[20px] text-brand-secondary leading-[1.55] whitespace-pre-wrap">
          {thread.content || thread.summary}
        </p>
      </div>

      {/* Deep Links Section */}
      {thread.deepLinks && thread.deepLinks.length > 0 && (
        <div className="mt-4 grid gap-2 pointer-events-auto">
          {thread.deepLinks.map((link, idx) => (
            <a key={idx} href={link.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-3 bg-brand-bg border border-brand-border rounded-[8px] hover:border-brand-mint transition-colors group">
              {link.thumbnail && (
                <img src={link.thumbnail} alt={link.title} className="w-10 h-10 rounded-[6px] object-cover bg-brand-surface flex-shrink-0" />
              )}
              <div className="flex items-center gap-2">
                {!link.thumbnail && <SafeIcon icon="Link" className="w-4 h-4 text-brand-muted group-hover:text-brand-mint transition-colors" />}
                <span className="text-[16px] md:text-[18px] font-bold text-brand-text group-hover:text-brand-mint transition-colors line-clamp-2">
                  {link.title || 'Visit Link'}
                </span>
              </div>
            </a>
          ))}
        </div>
      )}

      {/* Main Call To Action */}
      {thread.ctaText && thread.ctaUrl && (
        <a href={thread.ctaUrl} target="_blank" rel="noopener noreferrer" className="mt-4 block w-full py-3 bg-brand-mint text-brand-bg text-center text-[16px] md:text-[18px] font-bold rounded-[8px] hover:opacity-90 transition-opacity pointer-events-auto">
          {thread.ctaText}
        </a>
      )}
    </article>
  );
};

export default ThreadCard;